import React from 'react';
import { useLocation } from 'react-router-dom';

import { usePermissions } from '@/hooks/usePermissions';
import { Unauthorized } from '@/pages/Unauthorized';

/**
 * Trava de TODAS as telas do layout logado. Confere o endereço atual contra
 * a tabela única de `lib/route-access.ts` — a mesma que decide o que os
 * menus mostram. Sem ela, esconder um item do menu não impedia ninguém de
 * abrir a tela digitando o endereço (ou por um link salvo).
 *
 * Mostra o aviso DENTRO do layout, sem redirecionar: o endereço fica na
 * barra (a pessoa entende onde tentou entrar) e o menu lateral continua
 * disponível com o que ela pode abrir.
 */
export const RouteAccessGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { pathname } = useLocation();
  const { canAccessPath } = usePermissions();

  if (!canAccessPath(pathname)) return <Unauthorized embedded />;
  return <>{children}</>;
};

RouteAccessGuard.displayName = 'RouteAccessGuard';
